import React, { useState } from 'react';
import { api } from '../../api/client';

import { ta } from '../../i18n/adminT';
// Popup per creare (contact = null) o modificare una persona di riferimento.
// Non si chiude cliccando fuori dal riquadro, per non perdere i dati
// digitati con un clic accidentale.
export default function ReferenceContactFormModal({ contact, onClose, onSaved }) {
  const isEditing = Boolean(contact);
  const [form, setForm] = useState({
    nome: contact?.nome || '',
    cognome: contact?.cognome || '',
    email: contact?.email || '',
  });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.nome.trim() || !form.cognome.trim() || !form.email.trim()) {
      setError(ta('Nome, cognome ed email sono obbligatori.'));
      return;
    }
    setSaving(true);
    try {
      if (isEditing) {
        await api.updateReferenceContact(contact.id, form);
      } else {
        await api.createReferenceContact(form);
      }
      await onSaved();
      onClose();
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2 style={{ marginBottom: 14 }}>{isEditing ? ta('Modifica persona di riferimento') : ta('Nuova persona di riferimento')}</h2>
        {error && <div className="form-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="field-row">
            <div className="field">
              <label>{ta('Nome *')}</label>
              <input type="text" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} autoFocus />
            </div>
            <div className="field">
              <label>{ta('Cognome *')}</label>
              <input type="text" value={form.cognome} onChange={(e) => setForm({ ...form, cognome: e.target.value })} />
            </div>
          </div>
          <div className="field">
            <label>{ta('Email *')}</label>
            <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className="btn-row" style={{ marginTop: 16 }}>
            <button type="button" className="btn btn-ghost" onClick={onClose} disabled={saving}>{ta('Annulla')}</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? ta('Salvataggio…') : isEditing ? ta('Salva modifiche') : ta('Crea persona di riferimento')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
